import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LoaderService {
	private requestCount = 0;
	private loaderSubject = new BehaviorSubject<boolean>(false);
	readonly loader$ = this.loaderSubject.asObservable();

	private loaderButtonSubject = new BehaviorSubject<boolean>(false);
	readonly loaderButton$ = this.loaderButtonSubject.asObservable();

	show(): void {
		this.requestCount++;
		this.loaderSubject.next(true);
	}

	hide(): void {
		this.requestCount = Math.max(0, this.requestCount - 1);
		if (this.requestCount === 0) {
			this.loaderSubject.next(false);
		}
	}

	showInButton(): void {
		this.loaderButtonSubject.next(true);
	}

	hideInButton(): void {
		this.loaderButtonSubject.next(false);
	}
}
